import { Store } from 'vuex';
import ListModel from '../models/ListModel';
import Entity from './Entity';
import Point from './Point';

export default class ControllerStrategy {
  protected store: Store<any>;
  protected models: { [key: string]: ListModel };
  protected roomId: string;

  constructor(store: Store<any>, models: { [key: string]: ListModel }, roomId: string) {
    this.store = store;
    this.models = models;
    this.roomId = roomId;
  }

  get selected() {
    return this.store.state.mapControl.selected;
  }

  get selectedId() {
    return this.selected && this.selected.id;
  }

  get selectedType() {
    return this.selected && this.selected.type;
  }

  get offset() {
    return this.selected && this.selected.offset;
  }

  select(type: string, entity: Entity, location: Point): void {
    this.store.commit('selectEntity', {
      type,
      id: entity.id,
      offset: location,
    });
  }

  deselect(): void {
    this.store.commit('deselectEntity');
  }

  updateSelected(data: {}): void {
    if (!this.selected) return;
    const model = this.selectedType === 'character' ? this.models.characters : this.models.shapes;
    model.update(this.roomId, this.selectedId, data);
  }

  onMove(location: Point): void {}
  onStop(): void {}
  onTouchMap(location: Point, event: Event): void {}
  onTouchCharacter(location: Point, character: Entity): void {}
  onTouchShape(location: Point, shape: Entity): void {}
}
